// @flow

import { without } from 'lodash';

import type { GetState, TypedAction } from 'app/common/types';

export type RunStateMachine = (getState: GetState, action: TypedAction) => void;

export const INITIALIZE = '@@xstate/INITIALIZE';

export type StateMachineRegistry = {
  register: (...transitions: Array<RunStateMachine>) => void,

  unregister: (...transitions: Array<RunStateMachine>) => void,

  process: (getState: GetState, action: *) => void,
};

export const createStateMachineRegistry = (): StateMachineRegistry => {
  let pendingInitializations = [];
  let currentTransitions: Array<RunStateMachine> = [];

  return {
    register(...transitions: Array<RunStateMachine>) {
      currentTransitions = [...currentTransitions, ...transitions];
      pendingInitializations = [...pendingInitializations, ...transitions];
    },

    unregister(...transitions: Array<RunStateMachine>) {
      currentTransitions = without(currentTransitions, ...transitions);
      pendingInitializations = without(pendingInitializations, ...transitions);
    },

    process(getState, action) {
      pendingInitializations.forEach(transition =>
        transition(getState, { type: INITIALIZE })
      );
      pendingInitializations = [];

      if (action.type)
        // $FlowFixMe the enclosing conditional prevents processing anything but TypedActions
        currentTransitions.forEach(transition => transition(getState, action));
    },
  };
};
